<template>
  <div class="animated fadeIn">
    <v-col cols="12">
      <b-tabs pills card content-class="mt-3">
        <b-tab title="نمودارها">
          <v-row>
            <v-col>
              <br />
              <div class="text-center" v-if="loaded && step == 2">
                <h5>
                  فروش به تفکیک روز (میلیون ریال)
                  <v-btn color="primary" class="mr-5" @click="getChartData"
                    >گزارش ماهانه</v-btn
                  >
                </h5>
              </div>
              <div class="text-center" v-if="loaded && step == 1">
                <h5>فروش به تفکیک ماه (میلیون ریال)</h5>
              </div>
              <v-row>
                <v-col v-if="drillDownLoaded">
                  <bar-chart
                    :chartdata="invoiceAmountPerMonth"
                    :options="optionsDrill"
                    style="float: left"
                  >
                  </bar-chart>
                </v-col>
                <v-col class="text-center" v-else>
                  <v-progress-circular
                    :size="70"
                    :width="7"
                    color="primary"
                    indeterminate
                  ></v-progress-circular>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <br />
          <br />
          <v-row>
            <v-col cols="4" v-if="loaded">
              <div class="text-center">
                <h5>مبلغ چک‌ها به تفکیک وضعیت (میلیون ریال)</h5>
              </div>
              <pie-chart
                :chartdata="piechartChequeStatus"
                :options="optionsPie"
              >
              </pie-chart>
            </v-col>
            <v-col class="text-center" v-else>
              <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-col>
            <v-col cols="8" v-if="loaded">
              <div class="text-center">
                <h5>مبلغ چک‌ها برای یک هفته آینده (میلیون ریال)</h5>
              </div>
              <bar-chart :chartdata="chequeBar" :options="optionsBar">
              </bar-chart>
            </v-col>
            <v-col class="text-center" v-else>
              <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-col>
          </v-row>
          <br /><br />
          <v-row>
            <v-col cols="4" v-if="loaded">
              <div class="text-center">
                <h5>تعداد فروش به تفکیک نوع فاکتور</h5>
              </div>
              <pie-chart
                :chartdata="piechartInvoiceTypeNumbers"
                :options="optionsPie"
              >
              </pie-chart>
            </v-col>
            <v-col class="text-center" v-else>
              <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-col>
            <v-col cols="4" v-if="loaded">
              <div class="text-center">
                <h5>میزان فروش به تفکیک نوع فاکتور (میلیون ریال)</h5>
              </div>
              <pie-chart
                :chartdata="piechartInvoiceTypeIncomes"
                :options="optionsPie"
              >
              </pie-chart>
            </v-col>
            <v-col class="text-center" v-else>
              <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-col>
            <!-- </v-row>
          <br /><br />
          <v-row> -->

            <v-col cols="4" v-if="loaded">
              <div class="text-center">
                <h5>میزان فروش نقدی به تفکیک نوع پرداخت (میلیون ریال)</h5>
              </div>
              <pie-chart
                :chartdata="piechartIncomeTypeIncomes"
                :options="optionsPie"
              >
              </pie-chart>
            </v-col>
            <v-col class="text-center" v-else>
              <v-progress-circular
                :size="70"
                :width="7"
                color="primary"
                indeterminate
              ></v-progress-circular>
            </v-col>
          </v-row>
        </b-tab>
        <b-tab title="گزارش محصولات">
          <v-row class="p-0">
            <v-col class="pb-0 mt-3">
              <h6>
                <b-input-group size="md">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    placeholder="جستجو"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button
                      :disabled="!filter"
                      @click="filter = ''"
                      variant="danger"
                      >حذف</b-button
                    >
                  </b-input-group-append>
                </b-input-group>
              </h6>
            </v-col>
          </v-row>
          <br />

          <b-table
            responsive
            show-empty
            :items="allGoods"
            :fields="fields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
            :current-page="CurrentPage"
            :per-page="perPage"
            :busy="isBusy"
            :filter="filter"
            @filtered="onFiltered"
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(price)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }} ریال
              </div>
            </template>
            <template v-slot:cell(saleDefinite)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }} ریال
              </div>
            </template>
            <template v-slot:cell(saleRespite)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }} ریال
              </div>
            </template>
            <template v-slot:cell(saleProforma)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ Number(data.value).toLocaleString() }} ریال
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.index + 1 + perPage * (CurrentPage - 1) }}
              </div>
            </template>
            <div slot="table-isBusy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-pagination
            v-if="!isBusy"
            v-model="CurrentPage"
            :per-page="perPage"
            :total-rows="TotalRows"
            align="center"
            size="md"
            class="my-0"
            aria-controls="orders-list"
          ></b-pagination>
        </b-tab>
      </b-tabs>
    </v-col>
  </div>
</template>
<script>
import Axios from "axios";
import PieChart from "../../components/charts/PieExample.vue";
import BarChart from "../../components/charts/BarExample.vue";
export default {
  components: {
    PieChart,
    BarChart
  },
  data() {
    return {
      fields: [
        { key: "index", label: "#" },
        { key: "name", label: "نام" },
        { key: "price", label: "قیمت" },
        { key: "amountDefinite", label: "تعداد قطعی" },
        { key: "saleDefinite", label: "میزان فروش کل قطعی" },
        { key: "amountRespite", label: "تعداد امانی" },
        { key: "saleRespite", label: "میزان فروش کل امانی" },
        { key: "amountProforma", label: "تعداد پیش فاکتور" },
        { key: "saleProforma", label: "میزان فروش کل پیش فاکتور " }
      ],
      T: "",
      TotalRows: "",
      CurrentPage: 1,
      perPage: 10,
      isBusy: false,
      allGoods: [],
      filter: "",
      piechartInvoiceTypeNumbers: {},
      piechartInvoiceTypeIncomes: {},
      piechartIncomeTypeIncomes: {},
      piechartChequeStatus: {},
      invoiceAmountPerMonth: {},
      chequeBar: {},
      step: 1,
      pieGlobalColor: "97, 181, 70",
      barGlobalColor: "148,103,189",
      pieGlobalColor1: [96, 146, 205],
      pieGlobalColor2: [150, 150, 150],
      optionsPie: {
        responsive: true,
        legend: {
          usePointStyle: true,
          position: "bottom",
          labels: {
            fontFamily: "iransans"
          }
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans"
        }
      },
      optionsBar: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "میلیون ریال",
                fontFamily: "iransans"
              },
              ticks: {
                min: 0,
                fontFamily: "iransans"
              }
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans"
              },
              ticks: {
                fontFamily: "iransans"
              }
            }
          ]
        },
        legend: {
          display: false,
          position: "bottom",
          labels: {
            fontFamily: "iransans"
          }
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans"
        }
      },
      optionsDrill: {
        onClick: this.refreshChart,
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "میلیون ریال",
                fontFamily: "iransans"
              },
              ticks: {
                min: 0,
                fontFamily: "iransans"
              }
            }
          ],
          xAxes: [
            {
              scaleLabel: {
                display: false,
                labelString: "سال و ماه",
                fontFamily: "iransans"
              },
              ticks: {
                fontFamily: "iransans"
              }
            }
          ]
        },
        legend: {
          display: false,
          position: "bottom",
          labels: {
            fontFamily: "iransans"
          }
        },
        tooltips: {
          titleFontFamily: "iransans",
          bodyFontFamily: "iransans"
        }
      },
      loaded: false,
      drillDownLoaded: false
    };
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.TotalRows = filteredItems.length;
      this.CurrentPage = 1;
    },
    getGoods() {
      this.isBusy = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/reports/goods",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token")
          }
        }
      )
        .then(res => {
          this.isBusy = false;
          if (res.status == 200) {
            this.allGoods = res.data;
            this.T = this.allGoods.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch(err => {
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getChartData() {
      this.loaded = false;
      this.drillDownLoaded = false;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/reports/dashboard",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token")
          }
        }
      )
        .then(res => {
          if (res.status == 200) {
            this.step = 1;
            this.chequeBar = res.data.chequeBar;
            var barMaximum = Math.max(...this.chequeBar.datasets[0].data);
            this.chequeBar.datasets[0].backgroundColor = [];
            this.chequeBar.datasets[0].data.forEach((data, index) => {
              this.chequeBar.datasets[0].backgroundColor[index] =
                "rgba(" + this.barGlobalColor + "," + data / barMaximum + ")";
            });

            this.invoiceAmountPerMonth = res.data.invoiceAmountPerMonth;
            var barMaximum = Math.max(
              ...this.invoiceAmountPerMonth.datasets[0].data
            );
            this.invoiceAmountPerMonth.datasets[0].backgroundColor = [];
            this.invoiceAmountPerMonth.datasets[0].data.forEach(
              (data, index) => {
                this.invoiceAmountPerMonth.datasets[0].backgroundColor[index] =
                  "rgba(" + this.barGlobalColor + "," + data / barMaximum + ")";
              }
            );

            this.piechartChequeStatus = res.data.piechartChequeStatus;
            var pieCount = this.piechartChequeStatus.datasets[0].data.length;
            this.piechartChequeStatus.datasets[0].backgroundColor = [];
            var pieMax = Math.max(
              ...this.piechartChequeStatus.datasets[0].data
            );
            this.piechartChequeStatus.datasets[0].data.forEach(
              (data, index) => {
                // gradiential colors
                this.piechartChequeStatus.datasets[0].backgroundColor[index] =
                  "rgb(" +
                  parseInt(
                    (this.pieGlobalColor1[0] * data +
                      this.pieGlobalColor2[0] * (pieMax - data)) /
                      pieMax
                  ) +
                  "," +
                  parseInt(
                    (this.pieGlobalColor1[1] * data +
                      this.pieGlobalColor2[1] * (pieMax - data)) /
                      pieMax
                  ) +
                  "," +
                  parseInt(
                    (this.pieGlobalColor1[2] * data +
                      this.pieGlobalColor2[2] * (pieMax - data)) /
                      pieMax
                  ) +
                  ")";
              }
            );

            this.piechartIncomeTypeIncomes = res.data.piechartIncomeTypeIncomes;
            var pieCount = this.piechartIncomeTypeIncomes.datasets[0].data
              .length;
            this.piechartIncomeTypeIncomes.datasets[0].backgroundColor = [];
            var pieMax = Math.max(
              ...this.piechartIncomeTypeIncomes.datasets[0].data
            );

            this.piechartIncomeTypeIncomes.datasets[0].data.forEach(
              (data, index) => {
                // gradiential colors
                this.piechartIncomeTypeIncomes.datasets[0].backgroundColor[
                  index
                ] =
                  "rgb(" +
                  parseInt(
                    (this.pieGlobalColor1[0] * data +
                      this.pieGlobalColor2[0] * (pieMax - data)) /
                      pieMax
                  ) +
                  "," +
                  parseInt(
                    (this.pieGlobalColor1[1] * data +
                      this.pieGlobalColor2[1] * (pieMax - data)) /
                      pieMax
                  ) +
                  "," +
                  parseInt(
                    (this.pieGlobalColor1[2] * data +
                      this.pieGlobalColor2[2] * (pieMax - data)) /
                      pieMax
                  ) +
                  ")";
              }
            );

            this.piechartInvoiceTypeIncomes =
              res.data.piechartInvoiceTypeIncomes;
            var pieCount = this.piechartInvoiceTypeIncomes.datasets[0].data
              .length;
            this.piechartInvoiceTypeIncomes.datasets[0].backgroundColor = [];
            var pieMax = Math.max(
              ...this.piechartInvoiceTypeIncomes.datasets[0].data
            );

            this.piechartInvoiceTypeIncomes.datasets[0].data.forEach(
              (data, index) => {
                // gradiential colors
                this.piechartInvoiceTypeIncomes.datasets[0].backgroundColor[
                  index
                ] =
                  "rgb(" +
                  parseInt(
                    (this.pieGlobalColor1[0] * data +
                      this.pieGlobalColor2[0] * (pieMax - data)) /
                      pieMax
                  ) +
                  "," +
                  parseInt(
                    (this.pieGlobalColor1[1] * data +
                      this.pieGlobalColor2[1] * (pieMax - data)) /
                      pieMax
                  ) +
                  "," +
                  parseInt(
                    (this.pieGlobalColor1[2] * data +
                      this.pieGlobalColor2[2] * (pieMax - data)) /
                      pieMax
                  ) +
                  ")";
              }
            );

            this.piechartInvoiceTypeNumbers =
              res.data.piechartInvoiceTypeNumbers;
            var pieCount = this.piechartInvoiceTypeNumbers.datasets[0].data
              .length;
            this.piechartInvoiceTypeNumbers.datasets[0].backgroundColor = [];
            var pieMax = Math.max(
              ...this.piechartInvoiceTypeNumbers.datasets[0].data
            );

            this.piechartInvoiceTypeNumbers.datasets[0].data.forEach(
              (data, index) => {
                // gradiential colors
                this.piechartInvoiceTypeNumbers.datasets[0].backgroundColor[
                  index
                ] =
                  "rgb(" +
                  parseInt(
                    (this.pieGlobalColor1[0] * data +
                      this.pieGlobalColor2[0] * (pieMax - data)) /
                      pieMax
                  ) +
                  "," +
                  parseInt(
                    (this.pieGlobalColor1[1] * data +
                      this.pieGlobalColor2[1] * (pieMax - data)) /
                      pieMax
                  ) +
                  "," +
                  parseInt(
                    (this.pieGlobalColor1[2] * data +
                      this.pieGlobalColor2[2] * (pieMax - data)) /
                      pieMax
                  ) +
                  ")";
              }
            );
            setTimeout(() => {
              this.loaded = true;
              this.drillDownLoaded = true;
            }, 1000);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch(err => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    },
    refreshChart(evt, item) {
      var label = item[0]["_model"].label;
      this.step == 1 ? this.fetchMonthData(label) : "";
    },
    fetchMonthData(date) {
      this.drillDownLoaded = false;

      Axios.post(
        this.baseUrl + "/ppkpms/shop/reports/daily",
        {
          year: date.split("/")[0],
          month: date.split("/")[1]
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token")
          }
        }
      )
        .then(res => {
          if (res.status == 200) {
            this.step = 2;
            this.invoiceAmountPerMonth = res.data;
            var barMaximum = Math.max(
              ...this.invoiceAmountPerMonth.datasets[0].data
            );
            this.invoiceAmountPerMonth.datasets[0].backgroundColor = [];
            this.invoiceAmountPerMonth.datasets[0].data.forEach(
              (data, index) => {
                this.invoiceAmountPerMonth.datasets[0].backgroundColor[index] =
                  "rgba(" + this.barGlobalColor + "," + data / barMaximum + ")";
              }
            );

            setTimeout(() => {
              this.drillDownLoaded = true;
            }, 1000);
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch(err => {
          console.log(err);
          this.toast("خطا: " + err.response.data, "error");
          this.isBusy = false;
        });
    }
  },
  mounted() {
    this.getGoods();
    this.getChartData();
  }
};
</script>

<style scoped>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("./../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
